import * as Constants from '../../../constants';
import * as React from 'react';
import { Avatar } from '../../atoms';
import { CustomDropdown } from '../../atoms/Dropdown/Dropdown';
import { TextBlock } from '../../atoms';
import { useGlobalContext } from '../../context';
import UserDropdown from '../../atoms/UserDropdown/UserDropdown';
import useStyles from './Header.styles';

export const Header: React.FC = () => {
  const classes = useStyles();
  const { userdata } = useGlobalContext();
  const [selectedOption] = React.useState(
    window.location.href.includes('.cn') ? 'CHINA' : 'GLOBAL',
  );

  const options = [
    { value: 'CHINA', label: 'CHINA' },
    { value: 'GLOBAL', label: 'GLOBAL' },
  ];

  const handleOptionChange = (option: string) => {
    const currentRegionMatch =
      window.location.href.match(/https?:\/\/([^/]+)\//);
    if (!currentRegionMatch) return;

    const [, currentRegion] = currentRegionMatch;
    const regionSuffixMatch = currentRegion.match(/-(\w+)\./);
    const regionSuffix = regionSuffixMatch ? regionSuffixMatch[1] : '';

    const newRegionPrefix = regionSuffix ? `auto-${regionSuffix}` : 'auto';

    const baseDomain = currentRegion.includes('stg')
      ? Constants.BASE_DOMAIN_STG
      : currentRegion.includes('dev')
      ? Constants.BASE_DOMAIN_DEV
      : Constants.BASE_DOMAIN_PRD;

    const hostedZone =
      option === 'CHINA'
        ? Constants.HOSTED_ZONE_CHINA
        : Constants.HOSTED_ZONE_GLOBAL;

    const newURL = window.location.href.replace(
      /\/\/[^/]+\//,
      `//${newRegionPrefix}.${baseDomain}.${hostedZone}/`,
    );

    window.location.href = newURL;
  };

  return (
    <div className={classes.root}>
      <div className={classes.logoImage} data-qa-name="logoimage"></div>
      <div className={classes.verticalLine} data-qa-name="verticalline"></div>
      <div className={classes.appName} data-qa-name="appname">
        <TextBlock type="consoleHeaderTB" text="Canary console" />
      </div>
      <div className={classes.buildVersion} data-qa-name="buildversion">
        {process.env.REACT_APP_SEMVER || ''}
      </div>
      <div
        className={classes.consoleNameHeader}
        data-qa-name="canary_console_header"
      ></div>
      <div className={classes.user}>
        <div className={classes.userName} data-qa-name="username">
          <TextBlock type="userNameTB" text={userdata.username} />
        </div>
        <div className={classes.userAvatar} data-qa-name="avatar">
          <Avatar />
        </div>
      </div>
      <CustomDropdown
        selectedValue={selectedOption}
        options={options}
        handleValueChange={handleOptionChange}
        currentRegion={selectedOption}
      />
      <UserDropdown username={userdata.username} roles={userdata.roles} />
    </div>
  );
};
